import React from 'react';
import { SETA_LOGO_URL } from '../mock';

/**
 * Official SETA logo. The asset has a black background, so it blends naturally
 * on dark surfaces (header, about section, footer).
 */
const SetaLogo = ({ height = 56, className = '' }) => {
  return (
    <img
      src={SETA_LOGO_URL}
      alt="SETA Administração"
      style={{
        height,
        width: 'auto',
        objectFit: 'contain',
      }}
      className={`select-none ${className}`}
      draggable={false}
    />
  );
};

export default SetaLogo;
